<template>
<v-container class="text-left pa-5" v-if="user">
  <v-row>
    <v-col>
      <h1>{{ $t('userSettings.accountInfo') }}</h1>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <EditUserProfileImage />
    </v-col>
  </v-row>
  <v-row align="center">
    <v-col cols="2">{{ $t('admin.users.username') }}</v-col>
    <v-col cols="4"><v-text-field hide-details solo disabled v-model="user.userProfile.username"></v-text-field></v-col>
    <v-col cols="2"><EditUsernameDialog /></v-col>
  </v-row>
  <v-row align="center">
    <v-col cols="2">{{ $t('login.email') }}</v-col>
    <v-col cols="4"><v-text-field hide-details solo disabled v-model="user.email"></v-text-field></v-col>
    <v-col cols="2"><EditEmailDialog /></v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-btn :to="{ name: 'forgot-password'}">{{ $t('userSettings.changePassword') }}</v-btn>
    </v-col>
  </v-row>
</v-container>
<v-container v-else>
  <v-row class="text-left pa-5" >
    <v-col>
      <h1>{{ $t('userSettings.accountInfo') }}</h1>
    </v-col>
  </v-row>
  <v-row>
    <v-col>
      <v-skeleton-loader type=" list-item-three-line, card-heading" />
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import EditUsernameDialog from "@/views/UserSettings/EditUsernameDialog";
import EditEmailDialog from "@/views/UserSettings/EditEmailDialog";
import EditUserProfileImage from "@/views/UserSettings/EditUserProfileImage";
import hasLoggedInUser from "@/mixins/hasLoggedInUser";
export default {
  mixins: [hasLoggedInUser],
  components: {
    EditUsernameDialog,
    EditEmailDialog,
    EditUserProfileImage,
  },
}
</script>